import classNames from 'classnames'

import Paragraphs from '../ui/Paragraphs/Paragraphs'
import styles from './Headline.module.scss'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import { isLanguage } from '../../utils'

function Headline({ title, paragraphs = [], introduction = [], className }) {
  const { language } = useLanguage()
  const { isFrench } = isLanguage(language?.code)
  return (
    <div
      className={classNames(
        styles.headingComponent,
        isFrench ? styles['es_headingComponent'] : '',
        className
      )}
    >
      <h2>{title}</h2>
      <div className={styles.rightContainer}>
        <Paragraphs paragraphs={paragraphs} className={styles.paragraphs} />
        {introduction && introduction.length > 0 && (
          <div className={styles.bottomContainer}>
            {introduction.map((intr) => (
              <div
                key={'introduction' + intr?.id}
                className={styles.introduction}
              >
                <span className={styles.year}>{intr.year}</span>
                <span className={styles.description}>{intr.description}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Headline
